export default __webpack_public_path__ + "static/pamela1-57fc1115721f2edd2a7c553f9b4ec614.png";